import React, { useState } from "react";
import { fetchData } from "../../utility/adminApi";

function OrdersFilter({
  isOpen,
  onClose,
  setOrdersData,
  setCurrentPage,
  setTotalPage,
  currentPage,
  fetchOrders,
  setFilteredData,
  setShowModal,
  filteredData,
}) {
  const [formData, setFormData] = useState({
    start_amount_range: "",
    end_amount_range: "",
    cashier_name: "",
    customer_name: "",
    loyalty_plan: "",
    start_date: "",
    end_date: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetchData("orders", 1, "", formData);
      setOrdersData(response?.data?.data || []);
      setTotalPage(response?.data?.last_page);
      setCurrentPage(1);
      setFilteredData(formData);
      setShowModal(false);
    } catch (error) {
      console.error("Error filtering orders:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    setFormData({
      start_amount_range: "",
      end_amount_range: "",
      cashier_name: "",
      customer_name: "",
      loyalty_plan: "",
      start_date: "",
      end_date: "",
    });
    setFilteredData("");
    fetchOrders(1, "", "");
    setShowModal(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Filter Orders</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Start Amount Range
              </label>
              <input
                type="number"
                name="start_amount_range"
                value={formData.start_amount_range}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md px-3 py-2"
                placeholder="e.g., 100"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                End Amount Range
              </label>
              <input
                type="number"
                name="end_amount_range"
                value={formData.end_amount_range}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md px-3 py-2"
                placeholder="e.g., 2000"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Cashier Name
              </label>
              <input
                type="text"
                name="cashier_name"
                value={formData.cashier_name}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md px-3 py-2"
                placeholder="e.g., Testing"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Customer Name
              </label>
              <input
                type="text"
                name="customer_name"
                value={formData.customer_name}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md px-3 py-2"
                placeholder="e.g., Cashier Testing Default"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Loyalty Plan
              </label>
              <input
                type="text"
                name="loyalty_plan"
                value={formData.loyalty_plan}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md px-3 py-2"
                placeholder="e.g., Super bonus for client"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Start Date
              </label>
              <input
                type="date"
                name="start_date"
                value={formData.start_date}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md px-3 py-2"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                End Date
              </label>
              <input
                type="date"
                name="end_date"
                value={formData.end_date}
                onChange={handleInputChange}
                className="w-full border border-gray-300 rounded-md px-3 py-2"
              />
            </div>
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={handleClear}
              className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded"
            >
              Clear Filters
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50"
            >
              {isLoading ? "Filtering..." : "Apply Filters"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default OrdersFilter;
